import { ApplicationState } from '../..';

export const daccaCalculations = (state: ApplicationState) => state.details.detailsDacca.daccaCalculations;
export const caseCode = (state: ApplicationState) => state.details.detailsCase.caseCode;
export const claimNotificationId = (state: ApplicationState) => state.caseState.selectedCase.claimNotificationId;
export const policyConditions = (state: ApplicationState) => state.details.detailsPolicy.policy.conditions;
